var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading)?_c('div',{staticClass:"loading-indicator"},[_c('div',{staticClass:"flex items-center gap-8"},[_c('EstravelSymbolSpinnerSVG',{staticClass:"spinning-logo"}),_c('span',{staticClass:"text-sm font-medium text-primary"},[_vm._v(_vm._s(_vm.$t('info.updating_data')))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }